import classNames from 'classnames';
import moment from 'moment';
import React, {CSSProperties, FunctionComponent} from 'react';
import DatePicker from 'react-datepicker';
import {NewsPostEditorContentProps} from '../..';
import {InputLabelEditor} from '../../../InputLabelEditor';

const Styles: Record<string, CSSProperties> = {
  inputContainer: {
    marginBottom: 16,
  },
  toggleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  toggleLabelContainer: {
    marginLeft: 8,
  },
  toggleUnderLabel: {
    fontSize: 12,
    color: '#959DAF',
  },
  selectedToggleLabel: {
    fontWeight: 'bold',
    color: '#4054CC',
  },
};

export const NewsPostEditorMetaData: FunctionComponent<NewsPostEditorContentProps> = ({
  data,
  onChange,
  selectedDateToggle,
  isCreation,
  setSelectedDateToggle,
}) => {
  const immediateDate =
    data.publishedTimestamp &&
    moment(data.publishedTimestamp).isSameOrBefore(moment());

  return (
    <div>
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="NAME" isRequired />
        <input
          className="form-control"
          value={data?.name}
          onChange={e => onChange('name', e.target.value)}
        />
      </div>
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="DATE / HEURE" isRequired={!isCreation} />
        <div style={Styles.toggleContainer}>
          <div>
            <i
              style={{color: immediateDate ? '#4054CC' : 'black'}}
              onClick={() => {
                if (immediateDate) {
                  onChange('publishedTimestamp', undefined);
                } else {
                  setSelectedDateToggle(false);
                  onChange('publishedTimestamp', moment().utc().valueOf());
                }
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': immediateDate,
                'fa-toggle-off': !immediateDate,
              })}
            />
          </div>
          <div style={Styles.toggleLabelContainer}>
            <div style={immediateDate ? Styles.selectedToggleLabel : undefined}>
              envoi immédiat
            </div>
            <div style={Styles.toggleUnderLabel}>
              Une fois valider l’envoi est immédiat
            </div>
          </div>
        </div>
        <div style={Styles.toggleContainer}>
          <div>
            <i
              style={{color: selectedDateToggle ? '#4054CC' : 'black'}}
              onClick={() => {
                if (selectedDateToggle) {
                  setSelectedDateToggle(false);
                  onChange('publishedTimestamp', undefined);
                } else {
                  onChange('publishedTimestamp', undefined);
                  setSelectedDateToggle(true);
                }
              }}
              className={classNames('fa fa-2x', {
                'fa-toggle-on': selectedDateToggle,
                'fa-toggle-off': !selectedDateToggle,
              })}
            />
          </div>
          <div style={Styles.toggleLabelContainer}>
            <div
              style={
                selectedDateToggle ? Styles.selectedToggleLabel : undefined
              }>
              envoi différé
            </div>
            <div style={Styles.toggleUnderLabel}>Choisir une date</div>
          </div>
        </div>
        {selectedDateToggle && (
          <div style={{marginLeft: 35}}>
            <DatePicker
              selected={
                data.publishedTimestamp
                  ? new Date(data.publishedTimestamp)
                  : null
              }
              onChange={date => {
                if (moment(date).isSameOrBefore(moment())) {
                  setSelectedDateToggle(false);
                }
                onChange('publishedTimestamp', moment(date).utc().valueOf());
              }}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="d/M/yyyy hh:mm aa"
              timeCaption="time"
              placeholderText="Select Date"
            />
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NewsPostEditor/components/NewsPostEditorMetaData/index.tsx